import React from 'react'
import './ServiceSection.scss'
import { ReactComponent as Web } from '../../assets/services/web-icon.svg'
import { ReactComponent as Mobile } from '../../assets/services/mobile-icon.svg'
import { ReactComponent as Bots } from '../../assets/services/bot-icon.svg'
import { ReactComponent as Projects } from '../../assets/services/projects-icon.svg'
import { IService } from '../../models/services'
import ServiceCard from '../ServicesComponent/ServiceCard/ServiceCard'

interface ServiceSectionProps {
    
}

const ServiceSection:React.FC<ServiceSectionProps> = ({}) => {
    const data: IService[] = [
        {
            title: 'Websites Development',
            features: ['Landing Page', 'Corporative sites', 'Online shop', 'Catalog site' ,'İnformation portal','İndividual solutions'],
            icon: <Web/>
        },
        {
            title: 'Mobile Development',
            features: ['Native apps', 'Cross-platform software', 'Creating gaming platforms'],
            icon: <Mobile/>
        },
        {
            title: 'Bots and Parsers Development',
            features: ['Telegram bots creating', 'Facebook bots creating', 'Whatsapp bots creating', 'Parsers development', 'Chat bots creating'],
            icon: <Bots/>
        },
    ]
    return (
        <div className='ServiceSection'>
            <div className="serviceSection container">
                <div className="col-4 pe-2 info-block">
                    <div className="title">Services that we offer</div>
                    <div className="desc">
                        We provide the best services you need. We help you become better. We pride ourselves on helping our clients achieve great results when it comes to their projects.
                    </div>
                    <a href='/services' className="button primary-button see-all">See all services</a>
                </div>
                <div className="col-8 ps-2 services-block d-flex flex-wrap justify-content-center">
                    {data.map(service => {
                        return (
                            <div className="service-card p-3 col-6">
                                <div className="service-section-card">
                                    <div className="flip-card-front">
                                        {service.icon}
                                        <span>{service.title}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    <a href='/services' className="service-card p-3 col-6">
                        <div className="service-section-card">
                            <div className="flip-card-front">
                                <span className="title">
                                    9+
                                </span> 
                                <span>More Services</span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default ServiceSection